export default __webpack_public_path__ + "static/media/VarietyOptions.7eda9455.svg";